import { isNil } from 'ramda';
import PropTypes from 'prop-types';

import PropTypesPresenter from '../utils/PropTypesPresenter';
import CategoryPresenter from '../presenters/CategoryPresenter';
import CashbackPresenter from '../presenters/CashbackPresenter';
import RatePresenter from '../presenters/RatePresenter';
import { emptyValueToEmptyString } from '../utils/values';

import DatePresenter from './DatePresenter';

const ACTIVE = 'active';
const ARCHIVED = 'archived';

export default new PropTypesPresenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    weight: PropTypes.string,
    phoneNumber: PropTypes.string,
    normalOpeningHour: PropTypes.number,
    normalClosingHour: PropTypes.number,
    sundayOpeningHour: PropTypes.number,
    sundayClosingHour: PropTypes.number,
    customerServiceEmail: PropTypes.string,
    isFeatured: PropTypes.bool,
    email: PropTypes.string,
    logoUrl: PropTypes.string,
    imageUrl: PropTypes.string,
    locationMapUrl: PropTypes.string,
    shareableUrl: PropTypes.string,
    appUrl: PropTypes.string,
    storeNumber: PropTypes.string,
    merchantName: PropTypes.string,
    uniqueInState: PropTypes.bool,
    fastCashEnabled: PropTypes.bool,
    defaultCashbackRate: PropTypes.number,
    birthdayCashbackRate: PropTypes.number,
    state: PropTypes.string,
    billingAddress: PropTypes.string,
    transactionsData: PropTypes.shape(),
    cashbacksData: PropTypes.shape(),
    categories: PropTypes.arrayOf(CategoryPresenter.shape()),
    cashbacks: PropTypes.arrayOf(CashbackPresenter.shape()),
    defaultCashbackRates: PropTypes.arrayOf(RatePresenter.shape()),
    birthdayCashbackRates: PropTypes.arrayOf(RatePresenter.shape()),
  },
  {
    isActive(store) {
      return this.state(store) === ACTIVE;
    },
    isArchived(store) {
      return this.state(store) === ARCHIVED;
    },
    birthdayCashbackRateReadable(store) {
      return isNil(this.birthdayCashbackRate(store))
        ? '-'
        : this.birthdayCashbackRate(store);
    },
    normalServiceHoursText(store) {
      const openingHour = this.normalOpeningHour(store);
      const closingHour = this.normalClosingHour(store);

      return DatePresenter.workingHours(openingHour, closingHour);
    },
    saturdayServiceHoursText(store) {
      const openingHour = this.saturdayOpeningHour(store);
      const closingHour = this.saturdayClosingHour(store);

      return DatePresenter.workingHours(openingHour, closingHour);
    },
    sundayServiceHoursText(store) {
      const openingHour = this.sundayOpeningHour(store);
      const closingHour = this.sundayClosingHour(store);

      return DatePresenter.workingHours(openingHour, closingHour);
    },
    logoUrlReadable(store) {
      return emptyValueToEmptyString(this.logoUrl(store));
    },
    imageUrlReadable(store) {
      return emptyValueToEmptyString(this.imageUrl(store));
    },
    locationMapUrlReadable(store) {
      return emptyValueToEmptyString(this.locationMapUrl(store));
    },
  }
);
